import React, { useEffect, useState } from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch } from "react-redux";
import {
  setDrawerActiveMenu,
  setIsDrawerActive,
} from "../../store/features/webUtilitiesSlice";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { GET_MOOD_LIST, POST_MOOD_LIST } from "../../config/ApisCollection";
import { useNavigate } from "react-router-dom";

export default function MoodsView() {
  const dispatch = useDispatch();
  let history = useNavigate();
  const accessToken = secureLocalStorage.getItem("accessToken");
  const [data, setData] = useState([]);
  const [activeMood, setActiveMood] = useState(null);

  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(null));
    await dispatch(setIsDrawerActive(false));
  };

  const GetMoodList = async () => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    const formattedTime = currentDate.toTimeString().split(" ")[0];

    const post_body = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
      body: {},
    };
    try {
      await axios.get(GET_MOOD_LIST, post_body).then((response) => {
        //--------------------------
        if (response.data) {
          setData(response.data);
          response?.data?.forEach((item, index) => {
            if (item.log === true) {
              // console.log(response.data);
              setActiveMood(index);
            }
          });
        }

        //-------------------------
      });
    } catch (error) {
      console.log(error);
    }
  };

  const PosMoodList = async (itemid) => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    const formattedTime = currentDate.toTimeString().split(" ")[0];

    const post_body = {
      moodId: itemid,
    };
    const post_header = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    };
    await axios
      .post(POST_MOOD_LIST, post_body, post_header)
      .then((response) => {
        //--------------------------
        // console.log(response);

        setTimeout(() => {
          handleCloseDrawer();
          history(0);
        }, 3000);
        //-------------------------
      });
  };

  useEffect(() => {
    GetMoodList();
  }, []);

  return (
    <div className="w-full h-full">
      <div className="w-full flex mb-2">
        <SideBarBack
          className="bg-transparent"
          handleCloseDrawer={handleCloseDrawer}
        />
      </div>
      <div className="flex flex-col gap-2 mt-24 w-11/12 mx-auto pb-10">
        {activeMood != null ? (
          <div className="cardbox w-full border border-gray-200 shadow-md py-5 px-6 rounded-3xl">
            <div className="mode1">
              <img
                className="watchImg w-24 h-24 rounded-md"
                alt="watchImg"
                src={data[activeMood]?.imgUrl}
              />
              <div>
                <p className="cardboxtitle text-sm text-capitalize">
                  {data[activeMood]?.title}
                </p>
                <p className="text-[11px]">{data[activeMood]?.category}</p>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}

        <div className="grid grid-cols-4 gap-4 mt-10">
          {data.map((mood_row, index) => {
            return (
              <div
                key={index}
                className={
                  index == activeMood
                    ? "bg-orange text-white rounded"
                    : "cursor-pointer"
                }
                onClick={() => {
                  setActiveMood(index);
                  PosMoodList(mood_row.id);
                }}
              >
                <img
                  src={mood_row.imgUrl}
                  className="shadow-2xl rounded mb-2"
                  height={65}
                  width={65}
                />
                <p className="text-capitalize text-[8px] text-center">
                  {mood_row.title}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
